<template>
    <BasicModalWindow ref="modal_element" 
      @modalWindowClose='onClose'
      :class="wizard_class"
      :gtm="{
        module : 'whats_new',
        feature: `whats_new_${slides_names[slides_current]}_slide`,
        block  : `modal_header`,
        action : `cancel`
      }"
    >
        <template #title>
            <ul v-if="slides_loaded && slides_current < slides.length" ref="slider_navigation" class="navigation">
                <li v-for="item, $index in slides.length"
                    @click="onSetSlide($index)"
                    :key="item"
                    :class="{active : $index === slides_current}">
                      {{ item }}
                  </li>
            </ul>
        </template>
        <template #body>
            <div class="slider-container whats-new">
                <ul ref="slider_list" class="slider" :class="{'hidden': !slides_loaded}">
                    <li class="slide text-center">
                        <div class="premium-logo"></div>
                        <h2 class="bottom-space">SAPO Mail Premium</h2>
                        <p>
                          Lançámos uma versão melhorada do SAPO Mail, com 65GB de armazenamento, acesso via programas de email e remoção de publicidade, além de um conjunto de funcionalidades adicionais.
                        </p>

                          <LinkButton
                            :link="SAPOMailConfig.server.external_links.premium"
                            :text="'Aderir ao Premium'"
                            class='main-action half-top-space'
                            target="_blank"
                            :gtm="{
                              module : 'whats_new',
                              feature: `whats_new_${slides_names[slides_current]}_slide`,
                              block  : `modal_body`,
                              action : `premium_subscribe`
                            }"
                          />
                    </li>
                    <li class="slide text-center">
                        <div class="premium-logo"></div>
                        <h2 class="bottom-space">SAPO Mail Premium</h2>
                        <h3>Mais espaço</h3>
                        <p>Não queremos que falte espaço para as suas mensagens.<br> Tem 65GB de armazenamento com o Premium.</p>
                        <LinkButton
                            :link="SAPOMailConfig.server.external_links.premium"
                            :text="'Aderir ao Premium'"
                            class='main-action half-top-space'
                            target="_blank"
                            :gtm="{
                              module : 'whats_new',
                              feature: `whats_new_${slides_names[slides_current]}_slide`,
                              block  : `modal_body`,
                              action : `premium_subscribe`
                            }"
                          />
                    </li>

                    <li class="slide text-center">
                        <div class="premium-logo"></div>
                        <h2 class="bottom-space">SAPO Mail Premium</h2>
                        <h3>Acesso via programas de email</h3>
                        <p>Configure o SAPO Mail num programa de email, como Outlook ou Thunderbird, no seu PC, telemóvel ou tablet.</p>

                        <LinkButton
                          :link="SAPOMailConfig.server.external_links.premium"
                          :text="'Aderir ao Premium'"
                          class='main-action half-top-space'
                          target="_blank"
                          :gtm="{
                            module : 'whats_new',
                            feature: `whats_new_${slides_names[slides_current]}_slide`,
                            block  : `modal_body`,
                            action : `premium_subscribe`
                          }"
                        />

                    </li>

                    <li class="slide text-center">
                      <div class="premium-logo"></div>
                      <h2 class="bottom-space">SAPO Mail Premium</h2>
                      <h3>Sem publicidade</h3>
                      <p>Uma experiência ainda mais simples, com remoção de todos os formatos de publicidade.</p>
                      <LinkButton
                          :link="SAPOMailConfig.server.external_links.premium"
                          :text="'Aderir ao Premium'"
                          class='main-action half-top-space'
                          target="_blank"
                          :gtm="{
                            module : 'whats_new',
                            feature: `whats_new_${slides_names[slides_current]}_slide`,
                            block  : `modal_body`,
                            action : `premium_subscribe`
                          }"
                      />
                    </li>

                    <li class="slide text-center">
                      <div class="premium-logo"></div>
                      <h2 class="bottom-space">SAPO Mail Premium</h2>
                      <h3>E ainda:</h3>
                      <div>
                        <ul class="bullet-list">
                          <li>Reencaminhamento de mensagens.</li>
                          <li>Proteção para contas inativas.</li>
                          <li>Mais contactos, regras e envios.</li>
                        </ul>
                      </div>
                      <LinkButton
                          :link="SAPOMailConfig.server.external_links.premium"
                          :text="'Aderir ao Premium'"
                          class='main-action half-top-space'
                          target="_blank"
                          :gtm="{
                            module : 'whats_new',
                            feature: `whats_new_${slides_names[slides_current]}_slide`,
                            block  : `modal_body`,
                            action : `premium_subscribe`
                          }"
                      />
                    </li>

                    <li class="slide">
                        <h2>
                          Lançámos também novas funcionalidades para o plano base
                        </h2>
                        <h4 class="top-space">Bloqueio de endereços</h4>
                        <p>Adicione a uma “lista negra” endereços de email ou domínios completos que lhe enviem emails indesejados. Esses emails serão enviados diretamente para a pasta de Spam.</p>
                        <h4 class="top-space">Endereços incógnitos</h4>
                        <p>Crie endereços descartáveis para subscrever newsletters ou registar-se em serviços sem ter de fornecer o seu endereço real. Se um deles começar a receber spam, pode facilmente identificar a fonte e bloqueá-la.</p>
                    </li>
                </ul>
            </div>
        </template>

        <template #footer>
            <ActionButton v-show="slides_current > 0 && slides_current !== slides.length"
                @click="onPreviousSlide()"
                class='outline prev'
                text="global.actions.previous"
                :disabled="wizard_controller.state.events['submitting'] === 'loading'"
            />

            <ActionButton v-if="slides_current === slides.length - 1"
              @click="onClose()"
              class='main-action submit'
              text="global.actions.close"
              :gtm="{
                module : 'whats_new',
                feature: `whats_new_${slides_names[slides_current]}_slide`,
                block  : `modal_footer`,
                action : `close`
              }"
            />

            <ActionButton v-else-if="slides_current !== slides.length"
              @click="onNextSlide()"
              class='grey next'
              :text="'global.actions.next'"
              :loading="wizard_controller.state.events['submitting'] === 'loading'"
            />
        </template>
    </BasicModalWindow>
</template>

<script setup>
  import {ref, defineProps, reactive} from 'vue';
  import {onMounted}                  from 'vue';
  import BasicModalWindow             from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue';
  import WizardController             from '@/js/Settings/Wizard/WizardController.js'
  import LinkButton                   from '@/vue/Elements/Buttons/LinkButton.vue';
  import SAPOMailConfig               from '@/SAPOMailConfig';

  const props = defineProps({
    webmail_view : {},
  })

  const wizard_controller       = reactive(new WizardController());
  const wizard_class            = ref('wizard');
  const slider_list             = ref();
  const slides_loaded           = ref(false);
  const slides_current          = ref(0);
  const slides_previous         = ref(-1);
  const slides                  = ref([]);
  const slides_names            = ['welcome', 'storage', 'imap', 'no_ads', 'new_features'];

  onMounted(() => {
    setSlides();
    setSlidesTranslate();
    setSlidesLoaded(true);
    wizard_controller.saveCurrentConfiguration();
  })

  const onClose = async () => {
    await wizard_controller.whatsNew();
    props.webmail_view.closeModal('SETTINGS_WHATS_NEW');
  }

  const onNextSlide = () => {
    setCurrentSlide(slides_current.value + 1);
    setSlidesTranslate();
    setWizardClass();
  }

  const onPreviousSlide = () => {
    setCurrentSlide(slides_current.value - 1);
    setSlidesTranslate();
    setWizardClass();
  }

  const onSetSlide = (index) => {
    setCurrentSlide(index);
    setSlidesTranslate();
    setWizardClass();
  }

  const setSlidesTranslate = () => {
    if (slider_list.value) {
      slider_list.value.style.transform = `translateX(-${slides_current.value * 100}%)`;
    }


    // slides.value.forEach((slide, index) => {
    //   let translate_value = (index - slides_current.value ) * 100;

    //   if (translate_value >= 100) {
    //     translate_value = 100;
    //   }

    //   else if (translate_value <= -100) {
    //     translate_value = -100;
    //   }

    //   slide.style.transform = `translateX(${translate_value}%)`;

    //   if (index === slides_current.value || index === slides_previous.value) {
    //     slide.classList.add('animated');
    //     return;
    //   }

    //   slide.classList.remove('animated');

    // })
  }

  const setSlides = () => {
    slides.value = document.querySelectorAll('.slide');;
  }

  const setSlidesLoaded = (value) => {
    slides_loaded.value = value;
  }

  const setCurrentSlide = (value) => {
    slides_previous.value = slides_current.value;
    slides_current.value  = value;
  }

  const setWizardClass = () => {
    let wizard         = slides.value[slides_current.value].getAttribute('data-wizard');
    wizard_class.value = 'wizard';

    if (wizard) {
      wizard_class.value += ' ' + wizard;
    }
  }

</script>
